import React from "react";
import { Typography } from "@mui/material";

import FooterButtons from "./FooterButtons";
import SimplePaper from "../components/SimplePaper";

const CancellationAndRefundPolicy = () => {
  const title = "Cancellation & Refund Policy";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        At AstroData, we strive to provide the best possible experience for our
        users. This cancellation and refund policy outlines the terms and
        conditions for canceling services and requesting refunds.
      </Typography>

      <Typography variant="h4" gutterBottom>
        1. Cancellation Policy
      </Typography>
      <Typography variant="body1" paragraph>
        You may cancel your order for our services at any time before the
        service is delivered. To cancel your order, please contact our customer
        support team with your order details and reason for cancellation.
      </Typography>

      <Typography variant="h4" gutterBottom>
        2. Refund Policy
      </Typography>
      <Typography variant="body1" paragraph>
        We offer a 100% satisfaction guarantee on our services. If you are not
        satisfied with the service provided, you may request a refund within 30
        days of the service delivery. Refunds will be processed based on the
        following conditions:
      </Typography>
      <Typography variant="body1" paragraph>
        - The refund request is made within 30 days of the service delivery.
        <br />
        - The reason for the refund is clearly stated and falls within our
        acceptable refund criteria.
        <br />- The service has not been fully consumed or used.
      </Typography>

      <Typography variant="h4" gutterBottom>
        3. Non-Refundable Services
      </Typography>
      <Typography variant="body1" paragraph>
        Certain services are non-refundable, including but not limited to:
      </Typography>
      <Typography variant="body1" paragraph>
        - Personalized astrological reports that have already been delivered.
        <br />
        - Consultations that have been completed.
        <br />- Digital products that have been downloaded.
      </Typography>

      <Typography variant="h4" gutterBottom>
        4. Refund Process
      </Typography>
      <Typography variant="body1" paragraph>
        To request a refund, please contact our customer support team with your
        order details and reason for the refund. Once your request is received,
        we will review it and notify you of the approval or rejection of your
        refund. If approved, your refund will be processed, and a credit will
        automatically be applied to your original method of payment within a
        certain number of days.
      </Typography>

      <Typography variant="h4" gutterBottom>
        5. Late or Missing Refunds
      </Typography>
      <Typography variant="body1" paragraph>
        If you haven’t received a refund yet, first check your bank account
        again. Then contact your credit card company; it may take some time
        before your refund is officially posted. Next, contact your bank. There
        is often some processing time before a refund is posted. If you’ve done
        all of this and you still have not received your refund, please contact
        us.
      </Typography>

      <Typography variant="h4" gutterBottom>
        6. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions about our cancellation and refund policy,
        please contact us.
      </Typography>
    </>
  );
  return (
    <>
      <SimplePaper title={title} body={body} />

      <FooterButtons />
    </>
  );
};

export default CancellationAndRefundPolicy;
